import { MatPaginatorIntl } from '@angular/material/paginator';

export function dnaPaginatorIntl(): MatPaginatorIntl {
  const intl = new MatPaginatorIntl();
  intl.itemsPerPageLabel = 'Por página';
  intl.firstPageLabel    = 'Primeira página';
  intl.lastPageLabel     = 'Última página';
  intl.nextPageLabel     = 'Próxima página';
  intl.previousPageLabel = 'Página anterior';
  intl.getRangeLabel = (page: number, pageSize: number, length: number): string => {
    if (length === 0 || pageSize === 0) return `0 de ${length}`;
    length = Math.max(length, 0);
    const start = page * pageSize;
    const end   = Math.min(start + pageSize, length);
    return `${start + 1} – ${end} de ${length}`;
  };
  return intl;
}
